<template>
  <div class="topbar">
    <ul class="topbar-list">
      <li class="nav-item">
        <router-link
          to="/"
          class="nav-con"
        >
          官网首页
        </router-link>
      </li>
      <li class="nav-item">
        <a
          class="nav-con"
          href="javascript:void(0)"
          @click="GoNews(0)"
        >新闻资讯</a>
        <div class="sub-nav">
          <ul class="sub-nav-list">
            <li>
              <a
                href="javascript:void(0)"
                @click="GoNews(1)"
              >
                新闻
              </a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                @click="GoNews(2)"
              >公告</a>
            </li>
            <li>
              <a
                href="javascript:void(0)"
                @click="GoNews(3)"
              >活动</a>
            </li>
          </ul>
        </div>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-con"
          :to="{path:'/strate/list',query:{typeID:0}}"
        >
          攻略中心
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-con"
          to="/intro/list"
        >
          游戏介绍
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  methods: {
    GoNews (typeID) {
      this.$router.push({
        path: '/news/list',
        query: {
          typeID: typeID
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/topbar.vue